import baseUrl from "../baseUrl";
import xhr from "xhr";
import HttpError from "../../Api/Utils/HttpError";
import { withCsrfToken } from "../csrfToken";

/**
 * Need to be unpacked to store state.
 * TODO: Make it optional. I.e. make promiseRequestFactory to work without it.
 */
export const requestState = {
    requestsInProgress: 0,
};

/**
 * TODO: Make it optional too.
 */
export const requestMutations = {
    increaseRequestsInProgress(state) {
        state.requestsInProgress++;
    },
    decreaseRequestsInProgress(state) {
        state.requestsInProgress--;
    },
};

/**
 * Meant to be used in actions to create instance of promise request that api method can be initialized with.
 *
 * `context` - same context like in actions of Vuex.
 *
 * @deprecated No longer needed, just import api methods directly, as they no longer need to be initialized via `.init`.
 */
export function promiseRequestFactory(context) {
    return options => {
        return new Promise((resolve, reject) => {
            if (!options) {
                options = {};
            }

            if (options.url) {
                let url = options.url;
                if (url.length > 0 && url[0] === "/") {
                    url = baseUrl.get() + url;
                }
                options.url = baseUrl.fixOldV3(url);
            }

            if (!options.headers) {
                options.headers = {};
            }
            context.commit("increaseRequestsInProgress");

            const send = () => {
                xhr(options, (err, response) => {
                    if (err instanceof HttpError) {
                        if (err.statusCode === 0) {
                            err.message = "error.no_connection";
                        }
                        context.commit("decreaseRequestsInProgress");
                        return reject(err);
                    }
                    context.commit("decreaseRequestsInProgress");
                    return resolve(response);
                });
            };

            if ((options.method || "get").toLowerCase() === "get") {
                send();
            } else {
                withCsrfToken(csrfError => {
                    if (csrfError) {
                        context.commit("decreaseRequestsInProgress");
                        return reject(csrfError);
                    }

                    options.headers["X-Csrf-Token"] = window.panelCsrfToken;
                    send();
                });
            }
        });
    };
}
